/* eslint-disable @typescript-eslint/ban-ts-comment */

/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import React, { PureComponent } from 'react';
import MediaQuery from 'react-responsive';
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';
import VideoPlaylist from '../video-playlist';
import AdUnit from '../AdUnit';
import VideoSlider from '../video-slider';
import ShareButtons from '../share-buttons-react';
import NBCTruncate from '../nbc-truncate';
import VideoMeta from '../video-meta';
import { FastScheduleData } from '../nbc-jw-player/utils';

import {
  isMobile,
  metaPropHandler,
  VideoContentUnitProps,
} from '../nbc-jw-player/utils';

import './style.scss';

type VideoHeroProps = {
  accountId: string;
  brand: string;
  activeVideo: VideoContentUnitProps;
  nextUpSource?: string;
  callLetters: string;
  categoryName?: string;
  fastSchedule?: FastScheduleData[];
  fastHeroTitle?: string;
  fastHeroDek?: string;
  fromLive: boolean;
  setActiveVideo: (
    video: VideoContentUnitProps
  ) => void;
  setNextVideo: () => void;
  setTriggeredFromClick?: (
    boolean
  ) => void;
  fastEnabled?: boolean;
  fastEyebrow?: string;
  nextVideo: VideoContentUnitProps;
  nextVideoTriggered?: string;
  siteHost: string;
  station: string;
  twitterVia: string;
  videos: VideoContentUnitProps[];
};

const {
  wp: {
    i18n: {
      __,
      sprintf,
    },
  },
} = window;

export default class VideoHero extends PureComponent<VideoHeroProps> {
  /**
   * Set PropTypes for this component.
   * @type {object}
   */
  static defaultProps = {
    categoryName: __('Videos', 'nbc'),
    fastSchedule: [],
    fastEnabled: false,
    fastEyebrow: '',
    fastHeroTitle: '',
    fastHeroDek: '',
    nextUpSource: __('Videos', 'nbc'),
    nextVideoTriggered: 'first',
    setTriggeredFromClick: null,
  };

  componentDidMount() {
    this.displayExcerpt();
  }

  componentDidUpdate(props) {
    if (this.props.activeVideo !== props.activeVideo) {
      this.displayExcerpt();
    }
  }

  /**
   * Render an ad unit.
   */
  displayAdUnit = () => (
    <div className="video-hero__ad-unit">
      <div className="companion__ad-unit" />
      <AdUnit name="companiontopbox" />
      <AdUnit name="mobilemultibox" />
    </div>
  );

  /**
   * Check for read more
   */
  displayExcerpt = () => {
    const excerptLimit = isMobile ? 2 : 4;
    const excerpt = document.querySelector<HTMLElement>('.truncate__text > *') || document.querySelector<HTMLElement>('.truncate__text');
    if (excerpt) {
      const readToggle = document.querySelectorAll<HTMLElement>('.video-hero__text label')[0];
      excerpt.style.display = 'inline';
      const excerptLines = excerpt.getClientRects().length;

      if ('undefined' !== typeof readToggle) {
        readToggle.style.display = excerptLimit > excerptLines ? 'none' : 'block';
      }
    }
  };

  render() {
    const {
      nextUpSource,
      activeVideo,
      nextVideo,
      setNextVideo,
      setActiveVideo,
      videos,
      categoryName,
      setTriggeredFromClick,
      nextVideoTriggered,
      fromLive,
      accountId,
      siteHost,
      twitterVia,
      callLetters,
      station,
      brand,
      fastEnabled,
      fastEyebrow,
      fastHeroTitle,
      fastHeroDek,
      fastSchedule = [],
    } = this.props;

    const {
      eyebrow: {
        link: eyebrowLink = '',
        label: eyebrowLabel = '',
        sponsored: eyebrowSponsored = '',
      } = {},
      excerpt_link_display: {
        title: activeExcerptLinkTitle = '',
        link: activeExcerptLink = '',
      } = {},
      title: activeTitle,
      summary: activeExcerpt,
      link,
      date_string: objectDate,
      network_object_id: noid,
    } = activeVideo;

    const videoPlaylist = [{
      ...metaPropHandler(activeVideo),
    }, {
      ...metaPropHandler(nextVideo),
    }];

    let nextText = __('More Videos', 'nbc');

    if (nextUpSource || categoryName) {
      nextText = sprintf(
        /* translators: 1: category label */
        __('More %s Videos', 'nbc'),
        nextUpSource || categoryName
      );
    }

    const videoHeroClass = fastEnabled ? 'video-hero fast-enabled' : 'video-hero';

    return (
      <div className={videoHeroClass}>
        <div className="video-hero__column-wrapper">
          <div className="video-hero__column-left">
            <div className="video-hero__video">
              {
                <VideoPlaylist
                  autoplay
                  accountId={accountId}
                  brand={brand}
                  host={siteHost}
                  twitter={twitterVia}
                  callLetters={callLetters}
                  station={station}
                  videos={videoPlaylist}
                  hubCallback={setNextVideo}
                  continuousPlay={nextVideoTriggered}
                  fastSchedule={fastSchedule}
                />
              }
            </div>
          </div>
          <div className="video-hero__column-right">
            <div className="video-hero__info">
              {
                <VideoMeta
                  eyebrowLink={eyebrowLink}
                  eyebrowLabel={eyebrowLabel}
                  publishedTime={objectDate}
                  eyebrowSponsored={eyebrowSponsored}
                  fastEnabled={fastEnabled}
                  fastEyebrow={fastEyebrow}
                />
              }
              <h1 className="video-hero__title">
                {parse(DOMPurify.sanitize(fastEnabled ? fastHeroTitle : activeTitle))}
              </h1>
              <div className="video-hero__text">
                <input type="checkbox" id="expanded" />
                <NBCTruncate
                  maxlines="10"
                  maxlinesmobile="3"
                  readmore="Read More"
                  ellipsis="false"
                  text={fastEnabled ? fastHeroDek : activeExcerpt}
                />
                <label htmlFor="expanded" role="button" aria-label="expand" />
                {
                  0 < activeExcerptLink.length &&
                  <a
                    href={activeExcerptLink}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {0 < activeExcerptLinkTitle.length ?
                      activeExcerptLinkTitle :
                      activeExcerptLink
                    }
                  </a>
                }
              </div>
              {<ShareButtons
                // @ts-ignore
                title={parse(DOMPurify.sanitize(activeTitle))}
                href={link}
                noid={noid}
                isVideo
                fastEnabled={fastEnabled}
                fromLive={fromLive}
              />}
            </div>

            { /* Ad unit goes here */
              ! fastEnabled &&
              // @ts-ignore
              <MediaQuery minWidth={768}>
                {this.displayAdUnit()}
              </MediaQuery>
            }
          </div>
        </div>
        {
          (0 < videos.length && ! fastEnabled) &&
          <div className="video-hero__row">
            <h3 className="video-hero__row-title">
              {nextText}
            </h3>
            {
              <VideoSlider
                activeVideo={activeVideo}
                setActiveVideo={setActiveVideo}
                videos={videos}
                setTriggeredFromClick={setTriggeredFromClick}
                fromLive={fromLive}
              />
            }
          </div>
        }

        { /* Ad unit goes here */
          ! fastEnabled &&
          // @ts-ignore
          <MediaQuery maxWidth={767}>
            <div className="video-hero__row video-hero__row--centered">
              {this.displayAdUnit()}
            </div>
          </MediaQuery>
        }
      </div>
    );
  }
}
